import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PageInDevelopment from 'components/pages/PageInDevelopment';

// Admin components
import { UserManagement, RoleManagement } from 'components/admin';
import BusinessAreasPage from 'components/pages/BusinessAreasPage';

// Performance components
import BudgetControlPerformancePage from 'components/performance/BudgetControlPerformancePage';
import ObjectivesPage from 'components/performance/ObjectivesPage';

// User components
import Profile from 'components/pages/user/profile/Profile';

// Client components
import ClientDashboardPage from 'components/pages/ClientDashboardPage';
import ClientReportsPage from 'components/pages/ClientReportsPage';
import InfomediaPage from 'components/pages/InfomediaPage';

// Other components
import GeneralDashboard from 'components/dashboards/general/GeneralDashboard';
import DashboardBuilder from 'components/dashboards/customizable/DashboardBuilder';

// Mapa de rutas implementadas
const ROUTE_COMPONENTS = {
  '/': GeneralDashboard,
  '/dashboard/custom': DashboardBuilder,
  '/performance/metrics': BudgetControlPerformancePage,
  '/performance/objectives': ObjectivesPage,
  '/users': UserManagement,
  '/admin/roles': RoleManagement,
  '/business-areas': BusinessAreasPage,
  '/user/profile': Profile,
  '/infomedia': InfomediaPage,
  '/clients/dashboard': ClientDashboardPage,
  '/clients/reports': ClientReportsPage,
  // 
  // PARA AGREGAR NUEVAS RUTAS:
  // 1. Importa el componente arriba
  // 2. Agrega la línea aquí: '/ruta': Componente,
  // 3. ¡Listo! El admin puede asignar esa ruta a cualquier rol
  //
  // Ejemplo futuro:
  // '/finance': FinancePage,
  // '/inventory': InventoryPage,
  // '/reports/advanced': AdvancedReportsPage,
};

// Información sobre funcionalidades en desarrollo
const DEVELOPMENT_INFO = {
  '/settings': {
    title: 'Configuración del Sistema',
    description: 'Panel de configuración general de la aplicación',
    expectedFeatures: [
      'Configuración de notificaciones',
      'Parámetros del sistema',
      'Configuración de reportes',
      'Gestión de plantillas'
    ]
  },
  '/settings/global': {
    title: 'Configuración Global',
    description: 'Configuración avanzada del sistema',
    expectedFeatures: [
      'Configuración de base de datos',
      'Parámetros globales',
      'Configuración de seguridad',
      'Gestión de logs del sistema'
    ]
  },
  '/user/settings': {
    title: 'Configuración Personal',
    description: 'Personalización de tu experiencia de usuario',
    expectedFeatures: [
      'Preferencias de notificaciones',
      'Configuración de tema',
      'Idioma y región',
      'Configuración de privacidad'
    ]
  }
};

const DynamicRoute = () => {
  const location = useLocation();
  const path = location.pathname;

  // Buscar el componente correspondiente
  const Component = ROUTE_COMPONENTS[path];

  if (Component) {
    // Ruta implementada - renderizar el componente
    return <Component />;
  } else {
    // Ruta no implementada - mostrar página en desarrollo
    const devInfo = DEVELOPMENT_INFO[path] || {};
    
    return (
      <PageInDevelopment
        title={devInfo.title || `Funcionalidad: ${path}`}
        description={devInfo.description || 'Esta funcionalidad estará disponible próximamente'}
        expectedFeatures={devInfo.expectedFeatures || []}
      />
    );
  }
};

export default DynamicRoute; 